import cn from 'classnames'
import { FaThLarge, FaListUl, FaCalendarAlt } from 'react-icons/fa'

import s from './SwitchView.scss'

const SwitchView = ({ isCalendarView, isBoardView, changeView, hasCalendarView }) => (
  <div className={s.viewIconsWrapper}>
    <div
      onClick={() => changeView('list')}
      data-cy="change_view_list"
      className={cn(s.viewIcon, {
        [s.active]: !isBoardView && !isCalendarView
      })}
    >
      <FaListUl />
    </div>
    <div
      onClick={() => changeView('board')}
      data-cy="change_view_board"
      className={cn(s.viewIcon, {
        [s.active]: isBoardView
      })}
    >
      <FaThLarge />
    </div>
    {hasCalendarView && (
      <div
        onClick={() => changeView('calendar')}
        data-cy="change_view_calendar"
        className={cn(s.viewIcon, {
          [s.active]: isCalendarView
        })}
      >
        <FaCalendarAlt />
      </div>
    )}
  </div>
)

export default SwitchView
